import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { fetchDepartments } from '../store/actions/departments/departmentActions';

class DepartmentField extends Component {

  componentDidMount() {
    this.props.fetchDepartments();
  }

  render() {
    let departments = this.props.departments.departments;
    let department = this.props.department;

    let defaultValueIndex = null;
    let departmentOptions = [];

    if (!!departments && departments.length) {
      departmentOptions = +departments.length && departments.map(department => {
        return {
          label: department.department_name, 
          value: department.id
        }
      })
    }

    if (department) {
      if (typeof(departmentOptions) === 'object')  {
        departmentOptions.forEach((deptOpt, index) => {
          if (deptOpt.value === department) {
            defaultValueIndex = index;
          }
        })
      }
    }

    return (
      <Select 
        value={departmentOptions[defaultValueIndex]} 
        isSearchable={true}
        name="department"  
        isMulti={false} 
        options={departmentOptions} 
        onChange={(value) => this.props.onChangeCallback(value)}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  departments: state.departments 
})

const mapDispatchToProps = (dispatch) => ({
  fetchDepartments: () => dispatch(fetchDepartments())
})

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentField)